export default "0123456789abcdef";



// WEBPACK FOOTER //
// ./src/data/chars.js